import React from "react";
const SvgDsStairs = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M14.5 5a.5.5 0 01.5-.5h4.5a.5.5 0 01.5.5v16a.5.5 0 01-.5.5h-16A.5.5 0 013 21v-3.5a.5.5 0 010-1h4v-3a.5.5 0 010-1h4v-3a.5.5 0 010-1h4v-3a.5.5 0 01-.5-.5zm1.5.5V9a.5.5 0 01-.5.5H12V13a.5.5 0 01-.5.5H8V17a.5.5 0 01-.5.5H4v3h15v-15h-3z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsStairs;
